<div class="container" style="text-align: center; padding: 30px;">
  <h2>{{ statusMessage }}</h2>

  <ng-container *ngIf="success && paymentDetails">
    <div
      class="card"
      style="margin: 20px auto; padding: 20px; border: 1px solid #ccc; border-radius: 10px; max-width: 400px; text-align: left;"
    >
      <h3 style="text-align: center;">Payment Details</h3>
      <!-- <p><strong>Order ID:</strong> {{ paymentDetails.order_id }}</p>
      <p><strong>Status:</strong> {{ paymentDetails.status }}</p>
      <p><strong>Amount:</strong> ₹{{ paymentDetails.amount / 100 }}</p>
      <p><strong>Payment ID:</strong> {{ paymentDetails.id }}</p> -->

      <!-- Optional: show raw JSON -->
      <pre>{{ paymentDetails | json }}</pre>
    </div>
  </ng-container>
</div>
